import { Badge } from '@nepal-ecom/ui';

export const ORDER_STATUS_LABEL: Record<string, string> = {
  pending: 'Pending',
  payment_pending: 'Payment pending',
  payment_confirmed: 'Paid',
  processing: 'Processing',
  packed: 'Packed',
  shipped: 'Shipped',
  out_for_delivery: 'Out for delivery',
  delivered: 'Delivered',
  cancelled: 'Cancelled',
  return_requested: 'Return requested',
  return_approved: 'Return approved',
  returned: 'Returned',
  refunded: 'Refunded',
};

export const ORDER_STATUS_VARIANT: Record<
  string,
  'warning' | 'info' | 'success' | 'destructive' | 'secondary' | 'default'
> = {
  pending: 'warning',
  payment_pending: 'warning',
  payment_confirmed: 'info',
  processing: 'info',
  packed: 'info',
  shipped: 'default',
  out_for_delivery: 'default',
  delivered: 'success',
  cancelled: 'destructive',
  return_requested: 'warning',
  return_approved: 'warning',
  returned: 'secondary',
  refunded: 'secondary',
};

export function OrderStatusPill({ status }: { status: string }) {
  return (
    <Badge variant={ORDER_STATUS_VARIANT[status] ?? 'default'}>
      {ORDER_STATUS_LABEL[status] ?? status}
    </Badge>
  );
}

export const PAYMENT_LABEL: Record<string, string> = {
  esewa: 'eSewa',
  khalti: 'Khalti',
  cod: 'COD',
  wallet: 'Wallet',
  bank_transfer: 'Bank Transfer / QR',
};
